// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NpqS","title":"styles_title__23kQd"};